import React, { Component } from 'react';
import Select from './Select';
import Input from './Input';
import Output from './Output';
import '../../assets/styles/Converter/Form.sass';

class Form extends Component {
  constructor(props) {
    super(props);
    this.data = {};
    this.state = { hasSelectError: false, hasInputError: false };
  }

  componentWillReceiveProps() {
    this.data.valueToConvert = null;
    document.querySelector('form').reset();
  }

  capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  validateForm() {
    let hasSelectError = !this.data.from && !this.data.to;
    let hasInputError = !this.data.valueToConvert;
    let hasError = hasSelectError || hasInputError;

    if (hasError) {
      this.setState({ hasSelectError: hasSelectError, hasInputError: hasInputError });
      document.body.addEventListener('click', this.hideError.bind(this));
    }

    return !hasError;
  }

  hideError() {
    this.setState({ hasSelectError: false, hasInputError: false });
    document.body.removeEventListener('click', this.hideError.bind(this));
  }

  submitForm(e) {
    e.preventDefault();

    if (!this.validateForm()) return;

    this.props.onFormSubmit(this.data);
  }

  setData(data) {
    this.data = { ...this.data, ...data };
  }

  render() {
    return(
      <form className="Form" onSubmit={this.submitForm.bind(this)}>
        <fieldset className="Form__fieldset">
          <Select magnitude={this.props.magnitude}
                  setSelectedOption={this.setData.bind(this)}
                  name="from"
                  hasError={this.state.hasSelectError} />

          <Input placeholder="from"
                 setInputValue={this.setData.bind(this)}
                 hasError={this.state.hasInputError} />
        </fieldset>

        <fieldset className="Form__fieldset">
          <Select magnitude={this.props.magnitude}
                  setSelectedOption={this.setData.bind(this)}
                  name="to"
                  hasError={this.state.hasSelectError} />

          <Output placeholder="to"
                  setOutput={this.setData.bind(this)} />
        </fieldset>

        <input className="Form__button" type="submit" value="Convert it!" />
      </form>
    );
  }
}

export default Form;
